import React from 'react';

import colorsVars from 'styles/colors.module.scss';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { CustomizedTooltip } from 'components/common';
import classes from 'components/pages/DurationForecastPage/components/GraphComponents/components/ClusterActivities/components/FilterWarningIcon/FilterWarningIcon.module.scss';

const { warning } = colorsVars;

interface Props {
    showTotalActivities: boolean;
    filteredRowsLength: number;
}

export const FilterWarningIcon = ({ showTotalActivities, filteredRowsLength }: Props) => {
    return (
        <div className={classes.container}>
            {showTotalActivities ? (
                <CustomizedTooltip
                    triggerElement={
                        <div className={classes.icon}>
                            <MuiIcon icon={'errorOutline'} fontSize={'3rem'} color={warning} />
                        </div>
                    }
                    tooltipContent={`Showing first ${filteredRowsLength} activities. To see full list click on 'View in Project Activities’.`}
                    tooltipPosition={TooltipPosition.Bottom}
                />
            ) : null}
        </div>
    );
};
